import React, { useEffect, useState } from 'react';
import { Radio, RadioGroup, Box, FormLabel } from '@chakra-ui/react';

import { CheckRadioGroupInfo, GroupedCheckRadioGroupInfo } from '../../../types';

interface IProps {
  id?: string;
  items: CheckRadioGroupInfo[];
  groupedItems?: GroupedCheckRadioGroupInfo[];
  disabled?: boolean;
  radioListValue?: string;
  onChange: (value: string) => void;
}

export const CheckRadioGroupListV2 = ({
  id,
  items,
  groupedItems,
  disabled = false,
  radioListValue,
  onChange,
}: IProps): React.ReactElement => {
  const [listItems, setListItems] = useState<CheckRadioGroupInfo[] | GroupedCheckRadioGroupInfo[]>([]);
  let radioValue = '';
  if (groupedItems) {
    radioValue = radioListValue || groupedItems[0]?.options[0]?.value;
  } else if (items) {
    radioValue = radioListValue || items?.[0].value;
  }

  useEffect(() => {
    if (groupedItems) {
      setListItems(groupedItems);
    } else {
      setListItems(items);
    }
  }, [items, groupedItems]);

  const grouped = listItems as GroupedCheckRadioGroupInfo[];
  const nonGroupedItems = listItems as CheckRadioGroupInfo[];
  if (groupedItems) {
    return (
      <div id={id || 'CheckRadioList'}>
        {grouped.map((group, index) => (
          <Box key={`check-radio-group-list-container-${index}`} data-selector={`radio-group-${id || index}`}>
            <FormLabel as={'legend'} key={`check-radio-group-list-header-container-${index}`}>
              {group.label}
            </FormLabel>

            <RadioGroup
              name={`${id}-${index}`}
              id={`${id}-${index}`}
              data-selector="radio-group"
              onChange={onChange}
              isDisabled={disabled}
              value={radioValue}
            >
              {group.options.map(checkRadioGroup => (
                <Box key={checkRadioGroup.value}>
                  <Radio value={checkRadioGroup.value} data-selector={checkRadioGroup.label}>
                    {checkRadioGroup.label}
                  </Radio>
                </Box>
              ))}
            </RadioGroup>
          </Box>
        ))}
      </div>
    );
  }
  return (
    <RadioGroup
      name={id}
      id={id}
      data-selector={`radio-group${id ? `-${id}` : ''}`}
      onChange={onChange}
      isDisabled={disabled}
      value={radioValue}
    >
      {nonGroupedItems.map((checkRadioGroup, _index) => {
        return (
          <Radio
            key={checkRadioGroup.value}
            value={checkRadioGroup.value}
            data-selector={checkRadioGroup.label}
            aria-checked={checkRadioGroup.value === radioListValue}
            variant="ghost"
            mb="0.5"
          >
            {checkRadioGroup.label}
          </Radio>
        );
      })}
    </RadioGroup>
  );
};
